import type { SignUpDto } from './auth.type';
import { CompanyInfo } from './companyInfo.type';

export enum UserRole {
	Admin = 'admin',
	Customer = 'customer'
}

export enum UserType {
	Personal = 'personal',
	Business = 'Business'
}

export type User = {
	_id: string;
	email: string;
	name: string;
	phone: string;
	company?: string;
	role?: string;
	position?: string;
	team?: string;
	created_at: string;
	updated_at: string;
	deleted_at?: Date;
	department?: string;
	is_marketing_agreed?: Date | boolean | null;
	userType?: UserType;
	businessRegistrationNumber?: string;
	businessRegistrationFile?: string;
	company_ref?: CompanyInfo;
};

export type UpdateUserDto = Omit<SignUpDto, 'email' | 'password'>;
export type UpdateUserPasswordDto = {
	currentPassword: string;
	newPassword: string;
};

export type ResetPasswordDto = {
	hashKey: string;
	newPassword: string;
};
